import React, { useContext, useRef } from "react";
import styled from "styled-components";
import { useTheme } from "@material-ui/core/styles";
import ColorModeContext from "../../layout/themeContext";

let __themeToggleSeq = 0;

/**
 * Toggle dia/noite (styled-components).
 * `scale` escala o conjunto. Tamanho base: 59.5×34px (3.5em × 2em @ 17px).
 *
 * Semântica: checked = light, não-checked = dark.
 */
const Switch = ({ scale = 0.7 }) => {
  const theme = useTheme();
  const ctx = useContext(ColorModeContext);
  const toggle = ctx?.colorMode?.toggleColorMode || ctx?.toggleColorMode;
  const isDark = theme.mode === "dark" || theme.palette?.type === "dark";

  const idRef = useRef(null);
  if (idRef.current === null) {
    __themeToggleSeq += 1;
    idRef.current = `theme-toggle-${__themeToggleSeq}`;
  }
  const id = idRef.current;

  const handleChange = () => {
    if (typeof toggle === "function") toggle();
  };

  return (
    <StyledWrapper $scale={scale}>
      <label className="switch" htmlFor={id}>
        <input
          id={id}
          type="checkbox"
          checked={!isDark}
          onChange={handleChange}
        />
        <span className="slider" />
      </label>
    </StyledWrapper>
  );
};

const StyledWrapper = styled.div`
  display: inline-flex;
  transform: scale(${(p) => p.$scale});
  transform-origin: center;
  /* compensa o "espaço fantasma" — base ~59.5×34 */
  margin: ${(p) => `${(p.$scale - 1) * 17}px ${(p.$scale - 1) * 29.75}px`};

  .switch {
    font-size: 17px;
    position: relative;
    display: inline-block;
    width: 3.5em;
    height: 2em;
  }

  .switch input {
    opacity: 0;
    width: 0;
    height: 0;
  }

  .slider {
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #1a2238;
    transition: 0.4s;
    border-radius: 30px;
  }

  .slider:before {
    position: absolute;
    content: "";
    height: 1.4em;
    width: 1.4em;
    border-radius: 20px;
    left: 0.3em;
    bottom: 0.3em;
    background-color: #1a2238;
    box-shadow: inset 2px -2px 0 1.8px #fff;
    transition: 0.4s;
    animation: anima1 0.3s linear;
  }

  @keyframes anima1 {
    0% {
      transform: translateX(1.5em);
    }
    80% {
      transform: translateX(-0.3em);
    }
    100% {
      transform: translateX(0em);
    }
  }

  .switch input:checked + .slider:before {
    background-color: yellow;
    box-shadow: none;
    transform: translateX(1.5em);
    animation: anima 0.3s linear;
  }

  @keyframes anima {
    0% {
      transform: translateX(0px);
    }
    80% {
      transform: translateX(1.6em);
    }
    100% {
      transform: translateX(1.4em);
    }
  }
`;

export default Switch;
